import { combineEpics } from 'redux-observable';
import pageReady from './page-ready/index.tsx';
import queryChanged from './query-changed/index.tsx';
import retrieveDashboards from './retrieve-dashboards/index.tsx';

export default combineEpics(queryChanged, retrieveDashboards, pageReady);
